const numberFormatter = (num: number) => {
  const formattor = new Intl.NumberFormat(undefined, {
    notation: "compact",
  });
  return formattor.format(num);
};
export default numberFormatter;
